/* narin. — product accordions: single-select (one open at a time) + height/opacity animation. */
(function () {
  var OPEN = 320;
  var CLOSE = 260;

  function group(details) {
    return details.closest('.product__info-container') || details.closest('.product__info-wrapper') || document;
  }

  function animateOpen(details) {
    var content = details.querySelector('.accordion__content');
    if (!content) { details.open = true; return; }
    details.open = true;
    var target = content.scrollHeight;
    content.style.overflow = 'hidden';
    content.style.height = '0px';
    content.style.opacity = '0';
    requestAnimationFrame(function () {
      content.style.transition = 'height ' + OPEN + 'ms cubic-bezier(0.22,0.61,0.36,1), opacity ' + OPEN + 'ms ease';
      content.style.height = target + 'px';
      content.style.opacity = '1';
    });
    onEnd(content, function () {
      content.style.height = '';
      content.style.overflow = '';
      content.style.transition = '';
    });
  }

  function animateClose(details) {
    var content = details.querySelector('.accordion__content');
    if (!content) { details.open = false; return; }
    var start = content.scrollHeight;
    content.style.overflow = 'hidden';
    content.style.height = start + 'px';
    content.style.opacity = '1';
    requestAnimationFrame(function () {
      content.style.transition = 'height ' + CLOSE + 'ms cubic-bezier(0.4,0,0.2,1), opacity ' + CLOSE + 'ms ease';
      content.style.height = '0px';
      content.style.opacity = '0';
    });
    onEnd(content, function () {
      details.open = false;
      content.style.height = '';
      content.style.overflow = '';
      content.style.opacity = '';
      content.style.transition = '';
    });
  }

  function onEnd(content, fn) {
    function te(e) {
      if (e.target !== content || e.propertyName !== 'height') return;
      content.removeEventListener('transitionend', te);
      fn();
    }
    content.addEventListener('transitionend', te);
  }

  document.addEventListener('click', function (e) {
    var summary = e.target.closest('.product__accordion summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS') return;
    e.preventDefault();

    if (details.open) {
      animateClose(details);
      return;
    }
    // single-select: close any other open accordion in the same column
    group(details)
      .querySelectorAll('.product__accordion details[open]')
      .forEach(function (other) {
        if (other !== details) animateClose(other);
      });
    animateOpen(details);
  });
})();
